<template>
  <transition name="fade">
    <div v-show="isShowModal"
         class="overlay"
         @click="clickOnOverlay">
      <transition :name="animationType">
        <div v-if="isShowModal"
             :class="['wrap', {'center': centerContent}]">
          <slot />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Watch } from 'vue-property-decorator';

/**
 * Wrapper popup for show content which slide from below.
 */
@Component({
  props: {
    value: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    centerContent: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    animationType: {
      type:      String,
      default:   'default',
      required:  false,
      validator: value => [ 'default', 'collapse' ].indexOf(value) !== -1,
    },
    dialog: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    closeOnOverlay: {
      type:     Boolean,
      default:  false,
      required: false,
    },
  },
})
export default class MobileModal extends Vue {
  /**
   * Is show modal getter,
   * @return {Boolean}
   */
  get isShowModal() {
    return this.value;
  }
  /**
   * Is show modal setter.
   * @param {Boolean} value.
   */
  set isShowModal(value) {
    this.$emit('input', value);
  }

  /**
   * Watch for visibility modal state.
   */
  @Watch('isShowModal')
  visibilityChanged(value) {
    if (value) {
      this.addBackButtonInterceptor();
    } else {
      this.removeBackButtonInterceptor();
    }
  }

  /**
   * Add back button interceptor.
   */
  addBackButtonInterceptor() {
    document.addEventListener('backbutton', this.backButtonInterceptor, false);
  }

  /**
   * Remove back button interceptor.
   */
  removeBackButtonInterceptor() {
    document.removeEventListener('backbutton', this.backButtonInterceptor, false);
  }

  /**
   * History back interceptor.
   */
  backButtonInterceptor(e) {
    e.preventDefault();
    if (!this.dialog) {
      this.isShowModal = false;
    }
  }

  /**
   * Click on overlay event.
   */
  clickOnOverlay() {
    if (this.closeOnOverlay) {
      this.isShowModal = false;
    }
  }

  /**
   * Vue destroyed hook.
   */
  destroyed() {
    this.removeBackButtonInterceptor();
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/variables.scss';

$transition: .5s;

.overlay,
.wrap {
  position: fixed;
  top: var(--layout-offset-top);
  bottom: var(--layout-offset-bottom);
  left: 0;
  right: 0;
  width: 100%;
  height: var(--layout-height);
  z-index: 20;
}

.wrap.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay {
  background: $mobile-overlay-color;
  z-index: 15;
}

/* Overlay fade effect */
.fade-enter-active, .fade-leave-active {
  transition: $transition;
}
.fade-enter, .fade-leave-to {
  background: $mobile-overlay-color-leave;
}

/* Content collapse effect */
.collapse-enter-active, .collapse-leave-active {
  transition: $transition;
}
.collapse-enter, .collapse-leave-to {
  height: 0;
  top: 100%;
  opacity: .8;
}

/* Content collapse effect */
.default-enter-active, .default-leave-active {
  transition: $transition;
}
.default-enter, .default-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileModal.vue